import { environment } from '../environments/environment';
import { EnvironmentCode } from '../environments/environment.model';

export class LeadHelper {
  static readonly LEAD_OFFER_ID = 3;
  static readonly LEAD_EVENT_ID = 184;
  static readonly LEAD_TYPE_OFFER = 3;
  static readonly LEAD_TYPE_BROCHURE = 45;
  static readonly LEAD_TYPE_MUSTER = 46;
  static readonly LEAD_TYPE_AUSSCHREIBUNGSTEXTE = 47;
  static readonly LEAD_TYPE_CAD_DATEN = 64;
  static readonly LEAD_TYPE_PLANER_RELATIONSHIP = environment.env === EnvironmentCode.prod ? 384 : 724;
  static readonly IMPORT_COMPOSER_LEAD_SOURCE_ID = environment.env === EnvironmentCode.prod ? 383 : 843;
  static readonly LEAD_SOURCE_TELEFON = 2;
  static readonly LEAD_SOURCE_WEBSITE = environment.env === EnvironmentCode.prod ? 5 : 5;

  private static readonly svgClosedNames = {
    3: 'paper-announcement-closed',
    1: 'inbox-closed',
    24: 'window_exclamation-closed',
    44: 'window_type-closed',
    45: 'book-closed',
    46: 'rectangles-closed',
    47: 'ausschreibungstexte-closed',
    64: 'dwg-blau-closed',
    4: 'window_user-closed',
    344: 'event-lead-closed',
    184: 'event-lead-closed',
    [LeadHelper.LEAD_TYPE_PLANER_RELATIONSHIP]: 'user-gear', // close icon not provided
  };

  private static readonly svgNames = {
    3: 'paper-announcement',
    1: 'inbox',
    24: 'window_exclamation',
    44: 'window_type',
    45: 'book',
    46: 'rectangles',
    47: 'ausschreibungstexte',
    64: 'dwg-blau',
    4: 'window_user',
    344: 'event-lead',
    184: 'event-lead',
    [LeadHelper.LEAD_TYPE_PLANER_RELATIONSHIP]: 'user-gear',
  };


  private static readonly constructionSvgNames = {
    1: 'window-multipoints',
    2: 'window',
    3: 'window-arrows',
  };


  static getClassName( leadTypeId: number ): string {
    return this.svgNames[leadTypeId] ?? this.svgNames[1];
  }

  static getClosedClassName( leadTypeId: number ): string {
    return this.svgClosedNames[leadTypeId] ?? this.svgClosedNames[1];
  }

  static getAssetImage( leadTypeId: number, mobile = false ): string {
    return `assets/icons/${this.getClassName(leadTypeId)}${mobile ? '-mobile' : ''}.svg`;
  }

  static getClosedAssetImage( leadTypeId: number ): string {
    return `assets/icons/${this.getClosedClassName(leadTypeId)}.svg`;
  }

  static getConstructionIconUrl( typeId: number, isUrl: boolean, blue = false ): string {
    const result = (this.constructionSvgNames[typeId] ?? '') + (blue ? '-blue' : '');

    return isUrl ? `assets/icons/${result}.svg` : result;
  }
}
